export const baseUrl = (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')
  ? 'http://localhost:5001' 
  : 'https://api.compress-glb.com'; 

export const MAX_FILE_SIZE_MB = 10; 